import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <rect width={20} height={20} rx={4} ry={4} fill="fj-icons-bg-color" />
        <path
          fill="none"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 8.5l5 5 5-5"
        />
      </g>
    </g>
  </svg>
);

const DownArrow = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default DownArrow;
